<nav class="navbar" [class.scrolled]="scrolled">
  <div class="navbar__container">
    <a routerLink="/" class="navbar__brand" (click)="closeMenu()">
      <div class="brand-text">
        Natya Theerth
        <span>Kalai Koodam</span>
      </div>
    </a>

    <ul class="navbar__links" [class.open]="menuOpen">
      <li><a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" (click)="closeMenu()">HOME</a></li>
      <li><a routerLink="/about-guru" routerLinkActive="active" (click)="closeMenu()">GURU</a></li>
      <li><a routerLink="/vision" routerLinkActive="active" (click)="closeMenu()">VISION</a></li>
      <li><a routerLink="/bharatanatyam-levels" routerLinkActive="active" (click)="closeMenu()">BHARATANATYAM</a></li>
      <li><a routerLink="/contact" routerLinkActive="active" (click)="closeMenu()">CONTACT US</a></li>
      <li><a routerLink="/register" routerLinkActive="active" class="navbar__cta" (click)="closeMenu()">REGISTER</a></li>
    </ul>

    <button class="navbar__hamburger" [class.open]="menuOpen" (click)="toggleMenu()" aria-label="Toggle navigation">
      <span></span>
      <span></span>
      <span></span>
    </button>
  </div>
</nav>

<main class="main-content">
  <router-outlet></router-outlet>
</main>

<footer class="footer">
  <div class="container">
    <div class="footer__grid">
      <div class="footer__brand">
        <div class="brand-name">
          Natya Theerth
          <span>Kalai Koodam</span>
        </div>
        <p>Where every step tells a story.<br>கலையின் தீர்த்தத்தில் நடனம்</p>
      </div>

      <div>
        <h4>Navigation</h4>
        <ul>
          <li><a routerLink="/">Home</a></li>
          <li><a routerLink="/about-guru">Guru</a></li>
          <li><a routerLink="/vision">Vision</a></li>
          <li><a routerLink="/bharatanatyam-levels">Bharatanatyam</a></li>
          <li><a routerLink="/contact">Contact Us</a></li>
        </ul>
      </div>

      <div>
        <h4>Classes</h4>
        <ul>
          <li><a routerLink="/register">Register</a></li>
        </ul>
      </div>

      <div class="footer__contact">
        <h4>Contact Us</h4>
        <p>📧 sruthi&#64;natyatheerth.com</p>
        <p>📞 +1 902-441-8675</p>
        <p>📍 Halifax, NS, Canada</p>
        <br>
        <a routerLink="/contact" class="btn btn-secondary btn-sm">Get in Touch</a>
      </div>
    </div>

    <div class="footer__bottom">
      <p>&copy; {{ currentYear }} Natya Theerth Kalai Koodam. All rights reserved.</p>
      <p>Bharatanatyam | Halifax, NS | Est. 2018</p>
      <p class="footer__credit">
        Powered by 
        <a href="https://pringaconsultancyservices.com/" target="_blank" rel="noopener noreferrer">PCS &#10084;</a>
      </p>
    </div>
  </div>
</footer>
